<template>
  <v-app-bar v-if="me" app class="elevation-0">
    <v-app-bar-nav-icon
      v-if="!callActive"
      data-testid="nav-drawer-icon"
      class="nav-drawer-icon"
      @click.stop="toggleDrawer"
    />
    <v-toolbar-title data-testid="header-title">
      Store Space {{ moduleType }}
    </v-toolbar-title>
    <v-layout align-content-space-between justify-space-between>
      <v-flex class="mx-2">
        <v-btn
          data-testid="toolbar-facility-list-btn"
          class="toolbar-facility-list-btn px-3 mx-2"
          color="primary white--text"
          :to="{ name: 'search' }"
          v-show="salesSide"
        >
          <v-icon class="mr-3">business</v-icon>
          Facility List
        </v-btn>
        <global-tenant-search v-if="salesSide && callActive" />
        <v-btn
          id="toolbar-feedback-btn"
          data-testid="toolbar-feedback-btn"
          class="toolbar-feedback-btn px-3 mx-2"
          color="error"
        >
          <v-icon class="mr-3">bug_report</v-icon>
          Report Bug
        </v-btn>
        <v-btn
          data-testid="toolbar-facility-info-btn"
          class="toolbar-facility-info-btn px-3 mx-2"
          color="deep-purple lighten-2 white--text"
          @click="facilityInfoShow"
          v-show="callActive"
        >
          <v-icon class="mr-3">list_alt</v-icon>
          Facility Info
        </v-btn>
        <call-tracker />
      </v-flex>
      <v-menu data-testid="toolbar-profile-menu" class="toolbar-profile-menu">
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on" data-testid="dropdown-activator">
            <span>{{ me.first_name }} {{ me.last_name }}</span>
            <v-icon>arrow_drop_down</v-icon>
          </v-toolbar-title>
        </template>

        <v-list>
          <v-list-item>
            <v-switch
              data-testid="dark-theme-switch"
              class="dark-theme-switch"
              v-model="darkTheme"
              :prepend-icon="'light_mode'"
              :append-icon="'dark_mode'"
              inset
            />
          </v-list-item>
          <v-list-item
            data-testid="toolbar-logout-btn"
            class="toolbar-logout-btn"
            @click="logout"
          >
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-layout>
    <v-dialog v-model="facilityInfoModal" width="650">
      <v-card v-if="!facility.location_code">
        <v-card-text>
          <v-row>
            <v-col class="error--text subheading text-center">
              No facility selected. Please select a facility.
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-card-title class="text-h5 text-center ml-2">
          {{ facility.name }} ({{ facility.location_code }})
        </v-card-title>
        <v-card-text>
          <v-row class="ml-2">
            <v-col class="pb-0 subheading">Address: </v-col>
            <v-col class="pb-0 subheading">{{ facility.street_address }}</v-col>
          </v-row>
          <v-row class="mb-1 ml-2">
            <v-col class="pt-0" />
            <v-col class="pt-0 subheading">
              {{ facility.city }}, {{ facility.state }}
              {{ facility.postal_code }}
            </v-col>
          </v-row>
          <v-row class="mb-1 ml-2">
            <v-col class="subheading">Phone:</v-col>
            <v-col class="subheading">{{ addDashes(facility.phone) }}</v-col>
          </v-row>
          <v-row class="ma-2 pt-2">
            <v-col>
              <div class="text-h6 mb-3 font-weight-bold">Office Hours</div>
              <v-row
                class="mt-1 subheading"
                v-for="(hours, day) in facility.external_office_hours"
                :key="hours.i"
              >
                <v-col style="text-transform: capitalize">{{ day }}</v-col>
                <v-col v-if="hours.enabled && hours.open == hours.close">Open 24 Hours</v-col>
                <v-col v-else-if="hours.enabled && hours.open != hours.close">{{ hours.open }} - {{ hours.close }}</v-col>
                <v-col v-else>Closed</v-col>
              </v-row>
            </v-col>
            <v-divider vertical class="mr-3" />
            <v-col align-content-center>
              <div class="text-h6 mb-3 font-weight-bold">Access Hours</div>
              <v-row
                class="mt-1 subheading"
                v-for="(hours, day) in facility.external_access_hours"
                :key="hours.i"
              >
                <v-col style="text-transform: capitalize">{{ day }}</v-col>
                <v-col v-if="hours.enabled && hours.open == hours.close">24 Hour Access</v-col>
                <v-col v-else-if="hours.enabled && hours.open != hours.close">{{ hours.open }} - {{ hours.close }}</v-col>
                <v-col v-else>Closed</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            id="close-facility-info-modal-button"
            data-testid="close-facility-info-modal-button"
            class="close-facility-info-modal-button"
            color="green darken-1"
            text
            @click="facilityInfoModal = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CallTracker from "@/components/CallTracker";
import GlobalTenantSearch from "@/components/GlobalTenantSearch";

export default {
  data() {
    return {
      facility: [],
      facilityInfoLoading: false,
      facilityInfoModal: false
    };
  },

  computed: {
    ...mapState({
      me: (state) => state.user.me,
      twilioChat: (state) => state.application.twilioChat
    }),
    ...mapGetters({
      isAdmin: "isAdmin"
    }),
    userHasDocumentAccess() {
      return this.$store.getters.hasDocumentAccess;
    },
    darkTheme: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(newValue) {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        this.$store.dispatch("toggleDarkTheme", newValue);
      }
    },
    callActive() {
      return localStorage.getItem("callStarted");
    },
    moduleType() {
      if (this.$route.path.includes("/accounts-receivable")) {
        return "A/R Dashboard";
      } else {
        return "Call Center";
      }
    },
    salesSide() {
      return (
        this.callActive &&
        !this.twilioChat &&
        this.moduleType !== "A/R Dashboard"
      );
    }
  },

  methods: {
    toggleDrawer() {
      this.$store.dispatch(
        "toggleDrawer",
        !this.$store.state.application.settings.drawer
      );
    },
    logout() {
      this.$store.dispatch("logout");
    },
    facilityInfoShow() {
      this.facilityInfoModal = true;
      this.$store
        .dispatch("getFacility", this.$route.params.facilityId)
        .then((resp) => {
          let facility = resp.data.facility;
          this.$route.params.facilityId = resp.data.facility.id;
          this.facility = facility;
          this.facilityInfoLoading = false;
        })
        .catch((err) => {
          this.$store.dispatch("handleError", err);
          this.facilityInfoLoading = false;
        });
    },
    addDashes(phone) {
      if (phone) {
        if (phone.length === 10 && typeof phone.replace === "function") {
          return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else {
          return phone;
        }
      }
    },
    capitalize(day) {
      return day.charAt(0).toUpperCase() + day.substr(1);
    }
  },

  mounted() {
    let issueScript = document.createElement("script");
    issueScript.setAttribute(
      "src",
      "https://storespace.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-wkhk6e/b/45/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=17af6ca7"
    );
    document.head.appendChild(issueScript);

    let buttonScript = document.createElement("script");
    buttonScript.innerHTML = `window.ATL_JQ_PAGE_PROPS = {
                "triggerFunction": function(showCollectorDialog) {
                    jQuery("#toolbar-feedback-btn").click(function(e) {
                        e.preventDefault();
                        showCollectorDialog();
                    });
                },
            };`;
    document.head.appendChild(buttonScript);
  },

  components: {
    CallTracker,
    GlobalTenantSearch
  }
};
</script>
